// ── surface.js — поверхность панели (плитки, списки, блоки разделов) ──────────
// Одна точка вместо повторения «фон + рамка + тень» по экранам: тема решает, как выглядит
// панель. В плоских темах — сплошной C.card. В «Аркаде» — полупрозрачное переливчатое
// стекло (C.panelBg): сквозь него виден живой стол, а радужные блики — как в калейдоскопе.
// Окна и меню — floatSurface ниже. Кнопка-фишка («Колода») — chipFace в конце.

import { themeKit } from '../themes';

export const panelSurface = (C) => ({
  background: C.panelBg || C.card,
  border: `${C.borderW || 1}px solid ${C.border}`,
  boxShadow: C.panelShadow,
});

// Поле ввода — «колодец» темнее панели (C.fieldBg), без тени и кромки.
export const fieldSurface = (C) => ({
  background: C.fieldBg || C.card,
  border: `${C.borderW || 1}px solid ${C.border}`,
});

// Всплывающее: окна, листы снизу, меню. Плотнее панели (C.floatBg), кромка — та же
// (элементу ставится data-panel=""), тень — своя у каждого.
export const floatSurface = (C) => ({
  background: C.floatBg || C.card,
  border: `${C.borderW || 1}px solid ${C.border}`,
});

// Покерная фишка вместо кнопки с заливкой — в теме с kit.button 'chip' («Колода»).
// Круглая (round: ▶ и значки) — фишка сверху: обод с шестью светлыми вставками, тонкое
// кольцо, середина цветом фишки. С надписью — фишка-плашка: скруглённая, обод — вставки
// пунктиром по краю, внутри тонкое кольцо (index.css, [data-chip]::before). Толщина фишки —
// ребро снизу (--chip-edge).
// Цвета — C.chip, у опасной — C.chipDanger. В остальных темах — null (обычная заливка).
//   const chip = chipFace(C, { round: true });  <button {...chip?.attrs} style={{ …, ...chip?.style }}>
export function chipFace(C, { danger = false, round = false } = {}) {
  if (themeKit(C).button !== 'chip' || !C.chip) return null;
  const k = (danger && C.chipDanger) || C.chip;
  const background = round
    ? `radial-gradient(circle closest-side, ${k.fill} 0 60%, ${k.insert} 60% 66%, ${k.fill} 66% 74%, transparent 74.5%), `
      + `repeating-conic-gradient(from 15deg, ${k.insert} 0 22deg, ${k.fill} 22deg 60deg)`
    : `linear-gradient(180deg, rgba(255,255,255,.16), rgba(255,255,255,0) 55%), ${k.fill}`;
  return {
    attrs: { 'data-chip': round ? 'round' : '' },
    fg: k.ink,
    style: { background, backgroundOrigin: 'border-box', border: round ? `2px solid ${k.edge}` : `3px dashed ${k.insert}`, color: k.ink,
      borderRadius: round ? '50%' : 999, position: 'relative', '--chip-edge': k.edge, '--chip-insert': k.insert },
  };
}
